"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Networker = void 0;
var networker_cache_1 = require("./networker-cache");
var feature_flag_1 = require("./feature-flag");
var Networker = /** @class */ (function () {
    function Networker(interceptor) {
        this.interceptors = [];
        this.get = this.get.bind(this);
        this.request = this.request.bind(this);
        this.delete = this.delete.bind(this);
        this.post = this.post.bind(this);
        this.put = this.put.bind(this);
        this.ixpImpression = this.ixpImpression.bind(this);
        this.fetchRequest = this.fetchRequest.bind(this);
        if (interceptor) {
            this.registerIntercepor(interceptor);
        }
    }
    Networker.prototype.registerIntercepor = function (interceptor) {
        if (interceptor) {
            this.interceptors.push(interceptor);
        }
    };
    /**
     * Delete Rest API.
     * @param {string} url
     * @param {NetworkerMethodOptions} options.
     * @param {boolean} withCache. Optional. If true then do not use cache. Default is false => do not use cache.
     * @param {number} timeOutValue. Optional. If true then will timeout response after given time. Default is 0.
     * @returns {Promise<GenericResponse<T>>}
     */
    Networker.prototype.delete = function (url, options, withCache, timeOutValue, withIxpValue) {
        if (options === void 0) { options = {}; }
        return this.request(url, __assign(__assign({}, options), { method: 'DELETE' }), !withCache, timeOutValue, withIxpValue);
    };
    /**
     * Get Rest API.
     * @param {string} url
     * @param {NetworkerMethodOptions} options.
     * @param {boolean} withCache. Optional. If true then use cache. Default is false => No cache.
     * @param {number} timeOutValue. Optional. If true then will timeout response after given time. Default is 0.
     * @returns {Promise<GenericResponse<T>>}
     */
    Networker.prototype.get = function (url, options, withCache, timeOutValue, withIxpValue) {
        if (options === void 0) { options = {}; }
        return this.request(url, __assign(__assign({}, options), { method: 'GET' }), !withCache, timeOutValue, withIxpValue);
    };
    /**
     * Post Rest API.
     * If 'content-type' is not provided in the header and body is not of type FormData, set content-type is set to application/json'
     * If body is not string nor FormData, the function assume a JSON object is provided and stringify it.
     * @param {string} url
     * @param data. Can be any type. If FormData
     * @param {NetworkerMethodOptions} options.
     * @param {boolean} withCache. Optional. If true then use cache. Default is false => do not use cache.
     * @param {number} timeOutValue. Optional. If true then will timeout response after given time. Default is 0.
     * @returns {Promise<GenericResponse<T>>}
     */
    Networker.prototype.post = function (url, data, options, withCache, timeOutValue, withIxpValue) {
        if (options === void 0) { options = {}; }
        return this.request(url, __assign(__assign({ body: data }, options), { method: 'POST' }), !withCache, timeOutValue, withIxpValue);
    };
    /**
     * Put Rest API.
     * If 'content-type' is not provided in the header and body is not of type FormData, set content-type is set to application/json'
     * If body is not string nor FormData, the function assume a JSON object is provided and stringify it.
     * @param {string} url
     * @param data
     * @param {NetworkerMethodOptions} options
     * @param {boolean} withCache. Optional. If true then do use cache. Default is false => do not use cache.
     * @param {number} timeOutValue. Optional. If true then will timeout response after given time. Default is 0.
     * @returns {Promise<GenericResponse<T>>}
     */
    Networker.prototype.put = function (url, data, options, withCache, timeOutValue, withIxpValue) {
        if (options === void 0) { options = {}; }
        return this.request(url, __assign(__assign({ body: data }, options), { method: 'PUT' }), !withCache, timeOutValue, withIxpValue);
    };
    Networker.prototype.request = function (url, params, forceSendRequest, timeOutValue, withIxpValue) {
        withIxpValue = (withIxpValue !== undefined && withIxpValue !== null) ? withIxpValue : true;
        var originalParams = Object.assign({}, params);
        // if (timeOutValue === undefined) timeOutValue = 0;
        // didTimeOut => flag for checking timeout
        var didTimeOut = false;
        var timeout;
        var requestFromCache = networker_cache_1.networkerCache.get(url, params);
        /* Check Time Out - Starts */
        if (timeOutValue && timeOutValue > 0) {
            timeout = setTimeout(function () {
                didTimeOut = true;
                clearTimeout(timeout);
                var sMessage = "Request timed out after :: " + timeOutValue + " milliseconds";
                var newErrorObj = { "error": { "errorId": 'TIMEOUT_ERROR', "message": sMessage, "details": [{ "message": sMessage, "code": "999" }] } };
                // return Promise.reject(new Error('Request timed out after :: ' + timeOutValue + ' milliseconds'));
                return Promise.reject(newErrorObj);
            }, timeOutValue);
        }
        /* Check Time Out - Ends */
        if (!forceSendRequest && requestFromCache && requestFromCache.response) {
            return requestFromCache.response;
        }
        else {
            var response = this.fetchRequest(url, params, withIxpValue);
            if (this.unregister) {
                this.unregister();
            }
            if (!forceSendRequest && networker_cache_1.networkerCache.allowedMethod.includes(params.method)) {
                var customResponse = this.getCustomResponse(response);
                var networkerCacheDataRequest_1 = {
                    url: url,
                    requestOptions: originalParams,
                    response: customResponse,
                };
                if (requestFromCache && requestFromCache.response) {
                    networker_cache_1.networkerCache.delete(networkerCacheDataRequest_1);
                }
                response.then(function (response) {
                    if (!forceSendRequest) {
                        networker_cache_1.networkerCache.set(networkerCacheDataRequest_1);
                    }
                    if (!didTimeOut && timeOutValue !== undefined && timeOutValue > 0) {
                        clearTimeout(timeout);
                    }
                    return response;
                }).catch(function (error) {
                    networker_cache_1.networkerCache.delete(networkerCacheDataRequest_1);
                    return Promise.reject(error);
                });
                return customResponse;
            }
            return response;
        }
    };
    Networker.prototype.ixpImpression = function (response) {
        var featureFlag = new feature_flag_1.FeatureFlag();
        featureFlag.fetchIxpFlag(response);
    };
    Networker.prototype.fetchRequest = function (url, params, withIxpValue) {
        // execute interceptor request method and append url and config
        this.interceptors.forEach(function (item) {
            if (item && item.request) {
                var interceptedConfig = item.request(url, params);
                if (interceptedConfig && interceptedConfig.length > 1) {
                    url = interceptedConfig[0];
                    params = interceptedConfig[1];
                }
            }
        });
        params.headers = params.headers || {};
        var headers = new Headers(params.headers);
        // set default content-type: application/json
        if (!headers.has('content-type') && !(params.body instanceof FormData)) {
            headers.set('content-type', 'application/json');
        }
        // serialize body in case it is object
        if (typeof params.body !== 'string' && !(params.body instanceof FormData)) {
            params.body = JSON.stringify(params.body);
        }
        if (!params.credentials) {
            params.credentials = 'include';
        }
        var response = fetch(url, __assign(__assign({}, params), { headers: headers }));
        this.interceptors.forEach(function (item) {
            if (item && item.response) {
                item.response(url, response);
            }
        });
        if (withIxpValue && response) {
            this.ixpImpression(response);
        }
        return response;
    };
    Networker.prototype.safeExtract = function (type) {
        var _this = this;
        var res;
        return function (response) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (res) {
                    return [2 /*return*/, res];
                }
                res = response[type]();
                return [2 /*return*/, res];
            });
        }); };
    };
    ;
    Networker.prototype.getCustomResponse = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, response.then(function (res) { return ({
                        body: res.body,
                        bodyUsed: res.bodyUsed,
                        headers: res.headers,
                        ok: res.ok,
                        redirected: res.redirected,
                        status: res.status,
                        statusText: res.statusText,
                        type: res.type,
                        url: res.url,
                        json: _this.safeExtract('json').bind(_this, res),
                        text: _this.safeExtract('text').bind(_this, res),
                        arrayBuffer: _this.safeExtract('arrayBuffer').bind(_this, res),
                        blob: _this.safeExtract('blob').bind(_this, res),
                        formData: _this.safeExtract('formData').bind(_this, res),
                    }); })];
            });
        });
    };
    ;
    return Networker;
}());
exports.Networker = Networker;
//# sourceMappingURL=networker.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/networker/lib/networker.js
// module id = 1195
// module chunks = 8